(function (app, _) {

    app.constant("_", _);

})(window.app, window._);